import { addDoc, collection, doc, onSnapshot, orderBy, query, serverTimestamp, updateDoc, where } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../firebase";

export const isManagementHostname = () => {
  const hostname = window.location.hostname.toLowerCase();
  return hostname === "yonetim.argevio.com" ||
    hostname === "argevio-yonetim.web.app" ||
    hostname === "localhost";
};

export const isCustomerPortalHostname = () => {
  const hostname = window.location.hostname.toLowerCase();
  return hostname.endsWith(".argevio.com") && !isManagementHostname();
};

export const getCustomerPortalHostname = () =>
  window.location.hostname.toLowerCase();

export const resolveTenantId = (userData = {}) => {
  const hostname = getCustomerPortalHostname();
  if (hostname.endsWith(".argevio.com")) return hostname.split(".")[0];
  if (userData.tenantId) return userData.tenantId;
  if (Array.isArray(userData.tenantIds) && userData.tenantIds.length === 1) return userData.tenantIds[0];
  return "";
};

export const subscribeTickets = ({ tenantId, userId, management, onData, onError }) => {
  const constraints = management
    ? [orderBy("updatedAt", "desc")]
    : [where("tenantId", "==", tenantId), where("createdBy", "==", userId), orderBy("updatedAt", "desc")];
  return onSnapshot(query(collection(db, "supportTickets"), ...constraints),
    (snapshot) => onData(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))), onError);
};

export const createTicket = async ({ tenantId, companyId, companyName, user, subject, category, priority, message }) => {
  const ticket = await addDoc(collection(db, "supportTickets"), {
    tenantId, companyId, companyName, subject: subject.trim(), category, priority,
    status: "new", queueId: category.toLocaleLowerCase("tr-TR"), createdBy: user.uid,
    createdByName: user.displayName || user.email, assigneeId: "", assigneeName: "",
    sla: {}, lastMessageAt: serverTimestamp(), createdAt: serverTimestamp(), updatedAt: serverTimestamp()
  });
  await addMessage({ ticket: { id: ticket.id, tenantId }, user, body: message, visibility: "public", senderType: "customer", files: [] });
  return ticket.id;
};

export const subscribeMessages = ({ ticketId, management, onData, onError }) => {
  const constraints = management
    ? [orderBy("createdAt", "asc")]
    : [where("visibility", "==", "public"), orderBy("createdAt", "asc")];
  return onSnapshot(query(collection(db, "supportTickets", ticketId, "messages"), ...constraints),
    (snapshot) => onData(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))), onError);
};

export const addMessage = async ({ ticket, user, body, visibility, senderType, files = [] }) => {
  const attachments = [];
  for (const file of files) {
    const safeName = `${crypto.randomUUID()}-${file.name.replace(/[^a-zA-Z0-9._-]/g, "_")}`;
    const path = `supportAttachments/${ticket.tenantId}/${ticket.id}/${safeName}`;
    const uploaded = await uploadBytes(ref(storage, path), file, { contentType: file.type || "application/octet-stream" });
    attachments.push({ name: file.name, path, contentType: file.type, size: file.size, url: await getDownloadURL(uploaded.ref) });
  }
  await addDoc(collection(db, "supportTickets", ticket.id, "messages"), {
    body: body.trim(), visibility, senderType, senderId: user.uid,
    senderName: user.displayName || user.email, attachments,
    createdAt: serverTimestamp(), updatedAt: serverTimestamp()
  });
};

export const updateTicket = (ticketId, changes) => updateDoc(doc(db, "supportTickets", ticketId), {
  ...changes, updatedAt: serverTimestamp()
});
